import React, { useState } from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const data = {
  result: {
    log: [
      {
        points: [
          { point: [15, 18], centroId: 3 },
          { point: [30, 28], centroId: 1 },
          { point: [40, 37], centroId: 0 },
          { point: [11, 4], centroId: 3 },
          { point: [22, 14], centroId: 3 },
          { point: [29, 26], centroId: 1 },
          { point: [41, 38], centroId: 0 },
          { point: [2, 3], centroId: 3 },
          { point: [23, 20], centroId: 3 },
          { point: [32, 33], centroId: 1 },
          { point: [37, 47], centroId: 1 },
          { point: [7, 12], centroId: 3 },
          { point: [23, 13], centroId: 3 },
          { point: [28, 29], centroId: 1 },
          { point: [44, 37], centroId: 0 },
          { point: [5, 8], centroId: 3 },
          { point: [21, 16], centroId: 3 },
          { point: [34, 36], centroId: 1 },
          { point: [46, 45], centroId: 2 },
          { point: [4, 10], centroId: 3 },
          { point: [13, 17], centroId: 3 },
          { point: [27, 28], centroId: 1 },
          { point: [48, 43], centroId: 2 },
          { point: [5, 3], centroId: 3 },
          { point: [19, 16], centroId: 3 },
          { point: [29, 36], centroId: 1 },
          { point: [39, 39], centroId: 1 },
          { point: [12, 5], centroId: 3 },
          { point: [16, 20], centroId: 3 },
          { point: [36, 28], centroId: 1 },
          { point: [41, 42], centroId: 1 },
          { point: [2, 9], centroId: 3 },
          { point: [20, 19], centroId: 3 },
          { point: [28, 31], centroId: 1 },
          { point: [37, 37], centroId: 1 },
          { point: [3, 6], centroId: 3 },
          { point: [15, 23], centroId: 3 },
          { point: [28, 31], centroId: 1 },
          { point: [45, 46], centroId: 2 },
          { point: [9, 11], centroId: 3 },
          { point: [20, 14], centroId: 3 },
          { point: [27, 34], centroId: 1 },
          { point: [42, 40], centroId: 1 },
          { point: [11, 10], centroId: 3 },
          { point: [13, 24], centroId: 3 },
          { point: [28, 28], centroId: 1 },
          { point: [45, 45], centroId: 2 },
          { point: [11, 11], centroId: 3 },
          { point: [19, 13], centroId: 3 },
          { point: [30, 31], centroId: 1 },
        ],
        centroids: [
          { id: 0, point: [41.666666666666664, 37.333333333333336] },
          { id: 1, point: [32.333333333333336, 33.55555555555556] },
          { id: 2, point: [46, 44.75] },
          { id: 3, point: [12.84, 12.76] },
        ],
      },
      {
        points: [
          { point: [15, 18], centroId: 3 },
          { point: [30, 28], centroId: 1 },
          { point: [40, 37], centroId: 0 },
          { point: [11, 4], centroId: 3 },
          { point: [22, 14], centroId: 3 },
          { point: [29, 26], centroId: 1 },
          { point: [41, 38], centroId: 0 },
          { point: [2, 3], centroId: 3 },
          { point: [23, 20], centroId: 3 },
          { point: [32, 33], centroId: 1 },
          { point: [37, 47], centroId: 2 },
          { point: [7, 12], centroId: 3 },
          { point: [23, 13], centroId: 3 },
          { point: [28, 29], centroId: 1 },
          { point: [44, 37], centroId: 0 },
          { point: [5, 8], centroId: 3 },
          { point: [21, 16], centroId: 3 },
          { point: [34, 36], centroId: 1 },
          { point: [46, 45], centroId: 2 },
          { point: [4, 10], centroId: 3 },
          { point: [13, 17], centroId: 3 },
          { point: [27, 28], centroId: 1 },
          { point: [48, 43], centroId: 2 },
          { point: [5, 3], centroId: 3 },
          { point: [19, 16], centroId: 3 },
          { point: [29, 36], centroId: 1 },
          { point: [39, 39], centroId: 0 },
          { point: [12, 5], centroId: 3 },
          { point: [16, 20], centroId: 3 },
          { point: [36, 28], centroId: 1 },
          { point: [41, 42], centroId: 0 },
          { point: [2, 9], centroId: 3 },
          { point: [20, 19], centroId: 3 },
          { point: [28, 31], centroId: 1 },
          { point: [37, 37], centroId: 0 },
          { point: [3, 6], centroId: 3 },
          { point: [15, 23], centroId: 3 },
          { point: [28, 31], centroId: 1 },
          { point: [45, 46], centroId: 2 },
          { point: [9, 11], centroId: 3 },
          { point: [20, 14], centroId: 3 },
          { point: [27, 34], centroId: 1 },
          { point: [42, 40], centroId: 0 },
          { point: [11, 10], centroId: 3 },
          { point: [13, 24], centroId: 3 },
          { point: [28, 28], centroId: 1 },
          { point: [45, 45], centroId: 2 },
          { point: [11, 11], centroId: 3 },
          { point: [19, 13], centroId: 3 },
          { point: [30, 31], centroId: 1 },
        ],
        centroids: [
          { id: 0, point: [40.57142857142857, 38.57142857142857] },
          { id: 1, point: [29.692307692307693, 30.692307692307693] },
          { id: 2, point: [44.2, 45.2] },
          { id: 3, point: [12.84, 12.76] },
        ],
      },
      {
        points: [
          { point: [15, 18], centroId: 3 },
          { point: [30, 28], centroId: 1 },
          { point: [40, 37], centroId: 0 },
          { point: [11, 4], centroId: 3 },
          { point: [22, 14], centroId: 3 },
          { point: [29, 26], centroId: 1 },
          { point: [41, 38], centroId: 0 },
          { point: [2, 3], centroId: 3 },
          { point: [23, 20], centroId: 1 },
          { point: [32, 33], centroId: 1 },
          { point: [37, 47], centroId: 2 },
          { point: [7, 12], centroId: 3 },
          { point: [23, 13], centroId: 3 },
          { point: [28, 29], centroId: 1 },
          { point: [44, 37], centroId: 0 },
          { point: [5, 8], centroId: 3 },
          { point: [21, 16], centroId: 3 },
          { point: [34, 36], centroId: 0 },
          { point: [46, 45], centroId: 2 },
          { point: [4, 10], centroId: 3 },
          { point: [13, 17], centroId: 3 },
          { point: [27, 28], centroId: 1 },
          { point: [48, 43], centroId: 2 },
          { point: [5, 3], centroId: 3 },
          { point: [19, 16], centroId: 3 },
          { point: [29, 36], centroId: 1 },
          { point: [39, 39], centroId: 0 },
          { point: [12, 5], centroId: 3 },
          { point: [16, 20], centroId: 3 },
          { point: [36, 28], centroId: 1 },
          { point: [41, 42], centroId: 0 },
          { point: [2, 9], centroId: 3 },
          { point: [20, 19], centroId: 3 },
          { point: [28, 31], centroId: 1 },
          { point: [37, 37], centroId: 0 },
          { point: [3, 6], centroId: 3 },
          { point: [15, 23], centroId: 3 },
          { point: [28, 31], centroId: 1 },
          { point: [45, 46], centroId: 2 },
          { point: [9, 11], centroId: 3 },
          { point: [20, 14], centroId: 3 },
          { point: [27, 34], centroId: 1 },
          { point: [42, 40], centroId: 0 },
          { point: [11, 10], centroId: 3 },
          { point: [13, 24], centroId: 3 },
          { point: [28, 28], centroId: 1 },
          { point: [45, 45], centroId: 2 },
          { point: [11, 11], centroId: 3 },
          { point: [19, 13], centroId: 3 },
          { point: [30, 31], centroId: 1 },
        ],
        centroids: [
          { id: 0, point: [39.75, 38.25] },
          { id: 1, point: [28.846153846153847, 29.46153846153846] },
          { id: 2, point: [44.2, 45.2] },
          { id: 3, point: [12.416666666666666, 12.458333333333334] },
        ],
      },
    ],
  },
};

const colors = ["#68b038", "#3893b0", "#d81768", "#d9c518"];

const ClusteringChart = () => {
  const [step, setStep] = useState(0);

  const handleSliderChange = (event: any) => {
    setStep(Number(event.target.value));
  };

  const points = data.result.log[step].points.map((p) => ({
    x: p.point[0],
    y: p.point[1],
    centroidId: p.centroId,
  }));

  const centroids = data.result.log[step].centroids.map((c) => ({
    x: c.point[0],
    y: c.point[1],
    id: c.id,
  }));

  return (
    <div>
      <ScatterChart width={600} height={400}>
        <CartesianGrid />
        <XAxis type="number" dataKey="x" name="X-axis" />
        <YAxis type="number" dataKey="y" name="Y-axis" />
        <Tooltip cursor={{ strokeDasharray: "3 3" }} />
        <Legend />

        {/* Отображение точек */}
        {/* <Scatter name="Points" data={points} fill="#8884d8" shape="circle" /> */}
        {centroids.map((centroid) => {
          const currentCentroidPoints = points.filter(
            (el) => el.centroidId == centroid.id
          );
          return (
            <Scatter
              key={centroid.id}
              name="Points"
              data={currentCentroidPoints}
              fill={colors[centroid.id]}
              shape="circle"
            />
          );
        })}

        {/* Отображение центроидов */}
        {centroids.map((centroid) => {
          return (
            <Scatter
              name="Centroids"
              data={[
                {
                  x: centroid.x,
                  y: centroid.y,
                },
              ]}
              fill={colors[centroid.id]}
              shape="cross"
            />
          );
        })}
      </ScatterChart>

      <input
        type="range"
        min="0"
        max={data.result.log.length - 1}
        value={step}
        onChange={handleSliderChange}
      />
      <span>
        {" "}
        Шаг: {step + 1} из {data.result.log.length}
      </span>
    </div>
  );
};

export default ClusteringChart;
